// src/components/rapport/reportspages/club/ChartCapture.jsx
import { useEffect, useRef } from "react";
import { usePdfExport } from "./PdfExportContext";

export default function ChartCapture({ imageKey, children }) {
  const ref = useRef(null);
  const exporter = usePdfExport();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const raf = requestAnimationFrame(() => {
      const svg = el.querySelector("svg");
      if (!svg) return;

      try {
        const clone = svg.cloneNode(true);
        if (!clone.getAttribute("xmlns")) clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        if (!clone.getAttribute("xmlns:xlink")) clone.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");

        const xml = new XMLSerializer().serializeToString(clone);
        const svgUrl = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(xml);

        const { width, height } = svg.getBoundingClientRect();
        const w = Math.max(1, Math.floor(width));
        const h = Math.max(1, Math.floor(height));

        const img = new Image();
        img.onload = () => {
          const scale = 3;
          const canvas = document.createElement("canvas");
          canvas.width = w * scale;
          canvas.height = h * scale;
          const ctx = canvas.getContext("2d");
          ctx.setTransform(scale, 0, 0, scale, 0, 0);
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, w, h);
          ctx.drawImage(img, 0, 0, w, h);

          const pngDataUrl = canvas.toDataURL("image/png");
          exporter.setImage(imageKey, pngDataUrl);
        };
        img.onerror = (e) => console.error("ChartCapture rasterize error:");
        img.src = svgUrl;
      } catch (e) {
        
      }
    });

    return () => cancelAnimationFrame(raf);
  }, [imageKey, exporter, children]);

  return (
    <div ref={ref} className="w-full h-full" style={{ position: "relative" }}>
      {children}
    </div>
  );
}
